import { get } from '../../infra/rest';
import requestConfig from '../config/request';
import { SupportAccountManagerResponse } from '../typings/support-account-manger';

export const getSupportAccountManagerDetails = async (): Promise<SupportAccountManagerResponse> => {
  return get<SupportAccountManagerResponse>(
    `${requestConfig.aiBotBaseUrl}/v1/organization/account-owner/phones`,
    undefined,
    true,
    false,
    true
  );
};
